import { GA_DISABLE_PREFIX } from '@/constants/analytics';

export type GtagCommand = (
  ...args:
    | ['consent', 'update', { analytics_storage: 'denied' | 'granted' }]
    | ['config', string]
    | ['event', string, Record<string, string | number | boolean>]
) => void;

declare global {
  interface Window {
    gtag?: GtagCommand;
    [key: `${typeof GA_DISABLE_PREFIX}${string}`]: boolean | undefined;
  }
}

export function isGtagAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

export function gtagEvent(
  eventName: string,
  params: Record<string, string | number | boolean>,
): void {
  if (!isGtagAvailable()) return;
  window.gtag!('event', eventName, params);
}
